import dynamic from 'next/dynamic'

export const BentoThreeSquares = dynamic(
    () => import('./bento-three-squares'),
    { ssr: false },
)
